import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NavButtonsComponent } from '../nav_buttons.component';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../app_state';
import { Router } from '@angular/router';
import { FeatureService } from '../../services/feature.service';
import { ShopifyService } from '../../services/shopify.service';
import { REDCRSS_EVENTS } from '../../../../shared/services/constants/redcross_evemts';
import { MapState } from '../../../map/state/map-state';
import { WidgetState } from '../../../widget/state/widget_state';


@Component({
  selector: 'yi-setup-step-nav',
  template: require('./setup_step_nav.component.html'),
  styles: [require('../nav_buttons.components.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class SetupStepNavComponent extends NavButtonsComponent {

  private mapSettings: MapState;
  private widgetState: WidgetState;

  constructor(protected redCross: AnalyticsTrackingProvider,
              protected store: Store<IAppState>,
              protected router: Router,
              protected featureService: FeatureService,
              protected shopifyService: ShopifyService) {
    super(redCross, store, router, featureService, shopifyService);
    this.store.select(state => state.app.install.map).subscribe((data: MapState) => {
      this.mapSettings = data;
    });
    this.store.select(state => state.app.install.widget).subscribe((data: WidgetState) => {
      this.widgetState = data;
    });
  }

  nextClickedOn() {
    if (this.currentStep.name === 'NAVIGATION_TABS.CUSTOM_EMAILS') {
      this.redCross.identifiedTrack(REDCRSS_EVENTS.ACTIVATION_STEP, {
        product: REDCRSS_EVENTS.PRODUCT,
        stepName: REDCRSS_EVENTS.COLLECT_REVIEWS,
        stepNum: 1,
        status: REDCRSS_EVENTS.COMPLETED,
        isWidgetV3: this.isWidgetV3,
        isSkipped: 0,
        isEnabledMap: +this.mapSettings.enabled,
        isRetroactiveSend: +this.mapSettings.pastOrdersEnabled,
        numOfDays: this.mapSettings.pastOrders,
        isDomainUpdated: +this.mapSettings.signatureChanged,
        isSubjectUpdated: +this.mapSettings.subjectChanged,
        isBodyUpdated: +this.mapSettings.bodyChanged
      });
    } else if (this.currentStep.name === 'NAVIGATION_TABS.CUSTOM_WIDGETS') {
      this.redCross.identifiedTrack(REDCRSS_EVENTS.ACTIVATION_STEP, {
        product: REDCRSS_EVENTS.PRODUCT,
        stepName: REDCRSS_EVENTS.CUSTOMIZE_WIDGET,
        stepNum: 2,
        status: REDCRSS_EVENTS.COMPLETED,
        isWidgetV3: this.isWidgetV3,
        isSkipped: 0,
        isAutoPublishEnabled: +this.widgetState.autoPublish,
        isDesignUpdated: +(this.widgetState.fontChanged || this.widgetState.primaryColorChanged || this.widgetState.starRatingColorChanged),
      });
    }
    super.nextClickedOn();
  }

  backClickedOn() {
    if (this.currentStep.name === 'NAVIGATION_TABS.CUSTOM_WIDGETS') {
      this.redCross.identifiedTrack(REDCRSS_EVENTS.ACTIVATION_STEP, {
        product: REDCRSS_EVENTS.PRODUCT,
        stepName: REDCRSS_EVENTS.CUSTOMIZE_WIDGET,
        stepNum: 2,
        status: REDCRSS_EVENTS.BACK,
        isWidgetV3: this.isWidgetV3
      });
    }
    super.backClickedOn();
  }

  skipClickedOn() {
    if (this.currentStep.name === 'NAVIGATION_TABS.CUSTOM_EMAILS') {
      this.redCross.identifiedTrack(REDCRSS_EVENTS.ACTIVATION_STEP, {
        product: REDCRSS_EVENTS.PRODUCT,
        stepName: REDCRSS_EVENTS.COLLECT_REVIEWS,
        stepNum: 1,
        status: REDCRSS_EVENTS.COMPLETED,
        isWidgetV3: this.isWidgetV3,
        isSkipped: 1,
        isEnabledMap: +this.mapSettings.enabled,
        isRetroactiveSend: +this.mapSettings.pastOrdersEnabled,
        numOfDays: this.mapSettings.pastOrders,
        isDomainUpdated: +this.mapSettings.signatureChanged,
        isSubjectUpdated: +this.mapSettings.subjectChanged,
        isBodyUpdated: +this.mapSettings.bodyChanged
      });
    } else if (this.currentStep.name === 'NAVIGATION_TABS.CUSTOM_WIDGETS') {
      this.redCross.identifiedTrack(REDCRSS_EVENTS.ACTIVATION_STEP, {
        product: REDCRSS_EVENTS.PRODUCT,
        stepName: REDCRSS_EVENTS.CUSTOMIZE_WIDGET,
        stepNum: 2,
        status: REDCRSS_EVENTS.COMPLETED,
        isWidgetV3: this.isWidgetV3,
        isSkipped: 1,
        isAutoPublishEnabled: +this.widgetState.autoPublish,
        isDesignUpdated: +(this.widgetState.fontChanged || this.widgetState.primaryColorChanged || this.widgetState.starRatingColorChanged),
      });
    }
    super.skipClickedOn();
  }
}
